import { render, staticRenderFns } from "./DepositIssueForm.vue?vue&type=template&id=728338ca"
import script from "./DepositIssueForm.vue?vue&type=script&lang=js"
export * from "./DepositIssueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports